export default __webpack_public_path__ + "static/Fellix-Medium-3c56bfb20ca825055fc9e90d1e68485f.otf";